// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.miZlr{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:16px;width:100%;height:100%;text-align:center;padding:40px 64px}.miZlr.pAmWG{padding:24px}.SSh_p{background:linear-gradient(139deg, #2cf1ff 0%, #967bfb 51%, #ff7aaa 100%);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;max-width:809px}.EdLFy{margin-top:16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `miZlr`,
	"mobile": `pAmWG`,
	"headline": `SSh_p`,
	"button": `EdLFy`
};
export default ___CSS_LOADER_EXPORT___;
